import {Box, Flex, FormLabel, Input, Text} from '@chakra-ui/react';
import React, {useState, useRef, useEffect} from 'react';
import {CustomSelect} from '../General/FormInputs';
import {get} from '../../service/ApiService';
import {Client} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';

// Takes in register, errors, setValue from react-hook forms and an id for the form value when page is submitted.
export const ClientSelect = props => {
  const [toast, setToast] = useState('');
  const [clients, setClients] = useState([]);
  const clientInput = useRef(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (props.defaultValue) {
      clientInput.current.value = props.defaultValue;
      getClients();
    }
  }, []);

  useEffect(() => {
    if (props.defaultValue) {
      clientInput.current.value = props.defaultValue;
      getClients();
    }
  }, [props.defaultValue]);

  useEffect(() => {
    if (clients[0]) {
      if (props.useId) {
        setValue(clients[0].id);
        if (props.setRHFValue) props.setRHFValue(props.id, clients[0].id);
      } else {
        setValue(clients[0].clId);
        if (props.setRHFValue) props.setRHFValue(props.id, clients[0].clId);
      }

      if (props.setId) {
        props.setRHFValue('clientId', clients[0].id);
      }
    }
  }, [clients]);

  useEffect(() => {
    if (props.disabled) {
      clientInput.current.value = null;
    }
  }, [props.disabled]);

  const getClients = async () => {
    const data = clientInput.current.value;
    if (data === '') {
      return;
    } else if (data.match(/^[0-9]+$/) && data.length >= 4) {
      const response = await get(Client.CLIENT + '/get-by-code?clientCode=' + data);
      setClients([response]);
    } else if (data.toLowerCase().match(/^[a-z']+$/)) {
      const response = await get(Client.CLIENT + '/get-by-name?clientName=' + data);
      setClients(response.data);
    } else {
      setToast({response: {error: true}, errorMessage: 'Can not search by given code.  Please enter numbers or letters to search for clients'});
    }
  };

  return (
    <Flex mr="auto" alignContent="bottom">
      <Box mr="1">
        <FormLabel htmlFor="account-rep" mb="-0.5" ml="1" fontSize="sm">
          Select
        </FormLabel>
        <Input ref={clientInput} onBlur={getClients} placeholder="ID or Name" disabled={props.disabled ?? false} />
      </Box>

      <Box w="100%">
        <CustomSelect
          id={props.id}
          value={value}
          onChange={e => setValue(e.target.value)}
          register={props.register}
          errors={props.errors}
          name="Select Client"
          required={props.required ? props.required : false}
          disabled={props.disabled ?? false}
        >
          {clients == []
            ? []
            : clients.map(client => {
                return (
                  <option key={client.clId} value={props.useId ? client.id : client.clId}>
                    {client.clCname}
                  </option>
                );
              })}
        </CustomSelect>

        <ErrorHelper toastResponse={toast} />
      </Box>
    </Flex>
  );
};
